import React, { useRef } from "react";
import DateInput from "../../../components/inputs/DateInput";
import NumberInput from "../../../components/UIComponent/NumberInput";
import SwalServices from "../../../services/swalServices/SwalServices";
import CPASMemberServices from "../../../services/axiosServices/apiServices/CPASMemberServices";
import { Component } from "react-image-crop";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { checkParameters } from "../../../utils/Encryption";
import { TextInput } from "../../../components/allTypesInputComponents/AllTypeInputComponents";
import moment from "moment";
import { saveAs } from "file-saver";
import SendCpdRejectionReason from "../cPASApplication/SendCpdRejectionReason";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";

export default class CPDEditClaimApproval extends Component {
  constructor(props) {
    super(props);
    this.swaServices = new SwalServices();
    this.CPASMemberServices = new CPASMemberServices();
    this.state = {
      aCPActivityId: 0,
      cpdClaimApprovalDetail: {
        aCPActivityId: 0,
        certificateNumber: "",
        aCPName: "",
        activityName: "",
        dateOfIncorporation: "",
        activityDescription: "",
        claimPoints: 0,
        documentPath: "",
        acpContactNumber: "",
        activityTypeId: 0,
        cpdStatusId: 0,
        approvedPoints: 0,
        acpSearchText: "",
        acpValidationMessage: "",
        acpValidationType: "",
        registeredTo: "",
      },
      setRejectionReason: false,
      sendRejectionReason: "",
      isLoading: false,
      cpasMemberid: 0,
      courseStartTime: "",
      courseEndTime: "",
      openConfirmModel: false,
      openAcceptModel: false,

      cpasMembersList: [],
      activityList: [],

      cpasMembersListObj: {
        cpasMemberid: 0,
        fullName: "",
        certificateNumber: "",
        emailAddress: "",
        claimPoints: 0,
        courseName: "",
        dateOfIncorporation: "",
      },
      originalCpasMembersList: [],
      searchText: "",
      cpasMemberId: 0,
      messageAdd: "",
    };
  }

  componentDidMount = () => {
    const audit = getAuditContext()

    let params = new URLSearchParams(window.location.search);
    let aCPActivityId = params.get("");
    let cookie = getAuthProps();
    if (cookie) {
      this.setState({
        updatedBy: cookie.adminUserId,
        aCPActivityId: aCPActivityId,
      });
    }
    if (
      aCPActivityId &&
      (aCPActivityId = checkParameters(aCPActivityId, "Number"))
    ) {
      if (aCPActivityId > 0) {
        this.setState({ aCPActivityId }, () => {
          this.getCPDClaimApprovalDetailsById(aCPActivityId);
        });
      }
    }
    this.GetAllDropDownsForCPASMember();
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  };

  GetAllDropDownsForCPASMember = () => {
    this.CPASMemberServices.GetAllDropDownsForCPASMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let TierList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "ActivityType"
        );
        TierList.map(function (item) {
          delete item[ "dropdownName" ];
          return item;
        });
        this.setState({ activityList: TierList });
      }
    });
  };

  getCPDClaimApprovalDetailsById = (aCPActivityId) => {
    this.CPASMemberServices.getCPDClaimApprovalDetailsById(aCPActivityId).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let res = response.responseItem.responseContent;
          const details = {
            aCPActivityId: res.aCPActivityId,
            certificateNumber: res.acpRegistrationNumber,
            aCPName: res.acpName,
            activityName: res.activityName,
            dateOfIncorporation: res.dateOfIncorporation,
            activityDescription: res.activityDescription,
            claimPoints: res.claimPoints,
            documentPath: res.documentPath,
            acpContactNumber: res.acpContactNumber,
            activityTypeId: res.activityTypeId,
            cpdStatusId: res.cpdStatusId,
          };
          this.setState({ cpdClaimApprovalDetail: details });
        }
      }
    );
  };

  GetCPASMemberFiles = (type, Filepath) => {
    let request = [ this.state.cpasMemberid, type, Filepath ];
    this.setState({ isLoading: true });
    this.CPASMemberServices.GetCPASMemberFiles(request).then((response) => {
      if (response.data !== null && response.status === 200) {
        let formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
        let filename = "";
        filename = `${type}${formattedDate}`;
        const extension = Filepath.split(".").pop();
        let file = "";
        if (extension == "pdf") {
          file = new Blob([ response.data ], { type: "application/pdf" });
          URL.createObjectURL(file);
          window.open(URL.createObjectURL(file), "_blank");
          saveAs(file, `${filename}.${extension}`);
        } else {
          file = new Blob([ response.data ], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          URL.createObjectURL(file);
          saveAs(file, `${filename}.${extension}`);
        }
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  setOpenConfirmModel = (flag) => {
    this.setState({ openConfirmModel: flag });
  };

  setOpenAcceptModel = (flag) => {
    this.setState({ openAcceptModel: flag });
  };

  onDropdown = (id, drpIdentity) => {
    let details = { ...this.state.cpdClaimApprovalDetail };
    if (drpIdentity === "ActivityType") {
      details[ "activityTypeId" ] = id; // ✅ correct key
    }
    this.setState({ cpdClaimApprovalDetail: details });
  };

  searchApprovedCPASMemberList = () => {
    this.CPASMemberServices.searchApprovedCPASMemberList().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let detail = response.responseItem.responseContent;

        this.setState(
          { cpasMembersList: detail, originalCpasMembersList: detail },
          () => {
            console.log("CpasMembers List:", this.state.cpasMembersList);
          }
        );
      }
    });
  };
  handleACPNumberSearch = () => {
    const searchValue = this.state.acpSearchText?.trim();

    if (!searchValue) {
      this.setState({
        acpValidationMessage: "Please enter ACP Registration Number",
        acpValidationType: "error",
        registeredTo: "",
      });
      return;
    }

    this.CPASMemberServices.searchApprovedCPASMemberList().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        const list = response.responseItem.responseContent;

        const found = list.find(
          (item) =>
            item.certificateNumber?.toLowerCase() === searchValue.toLowerCase()
        );

        if (found) {
          this.setState({
            acpValidationMessage: "Valid ACP Registration Number",
            acpValidationType: "success",
            registeredTo: found.fullName,
            cpasMemberId: found.cpasMemberId,
          });
        } else {
          this.setState({
            acpValidationMessage:
              "ACP Registration Number Not Found. Invalid Member",
            acpValidationType: "error",
            registeredTo: "",
            cpasMemberId: 0,
          });
        }
      }
    });
  };
  handleRowSelect = (cpasMemberId) => {
    const updatedList = this.state.cpasMembersList.map((item) => ({
      ...item,
      isSelected: item.cpasMemberId === cpasMemberId,
    }));

    this.setState({
      cpasMembersList: updatedList,
      selectAll: false,
    });
  };

  handleSelectAll = (e) => {
    const checked = e.target.checked;

    const updatedList = this.state.cpasMembersList.map((item) => ({
      ...item,
      isSelected: checked,
    }));

    this.setState({
      cpasMembersList: updatedList,
      selectAll: checked,
    });
  };

  validateBeforeApproveReject = (actionType) => {
    const { approvedPoints } = this.state.cpdClaimApprovalDetail;
    const { acpSearchText, registeredTo } = this.state;
    if (actionType === "approve") {
      if (!approvedPoints && approvedPoints !== 0) {
        this.swaServices.Warning("Please enter Approved Points.");
        return false;
      }
      if (Number(approvedPoints) <= 0) {
        this.swaServices.Warning("Approved Points must be greater than 0.");
        return false;
      }
    }
    if (!acpSearchText) {
      this.swaServices.Warning("Please enter ACP Registration Number.");
      return false;
    }
    if (!registeredTo) {
      this.swaServices.Warning("Please search and select valid ACP member.");
      return false;
    }

    return true;
  };

  searchByName = (value) => {
    const searchText = value.toLowerCase();

    const filteredList = this.state.originalCpasMembersList.filter((item) => {
      return (
        (item.certificateNumber &&
          item.certificateNumber.toLowerCase().includes(searchText)) ||
        (item.fullName && item.fullName.toLowerCase().includes(searchText)) ||
        (item.emailAddress &&
          item.emailAddress.toLowerCase().includes(searchText))
      );
    });

    this.setState({
      searchText: value,
      cpasMembersList: filteredList,
    });
  };

  approvedCPD = (isAccpet) => {
    const message = isAccpet
      ? "Are you sure you want to accept?"
      : "Are you sure you want to reject?";

    this.swaServices.Confirm(message, "", "Yes", "No").then((response) => {
      if (!response) return;

      this.setState({
        isLoading: true,
        actionType: isAccpet ? "approve" : "reject",
      });

      const request = {
        ACPActivityId: this.state.aCPActivityId,
        CpasMemberId: this.state.cpasMemberId,
        ClaimPoints: this.state.cpdClaimApprovalDetail.claimPoints,
        approvedPoints: this.state.cpdClaimApprovalDetail.approvedPoints ?? 0,
        CPDStatusId: isAccpet ? 1 : 2,
        IsAccpet: isAccpet,
        RejectionReason: this.state.sendRejectionReason,
      };

      this.CPASMemberServices.approvedCPDPoints(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            this.swaServices
              .Success(
                isAccpet
                  ? "The CPD Point Successfully Approved."
                  : "The CPD Point has been Rejected."
              )
              .then(() => {
                window.location.reload();
              });
          }
        })
        .finally(() => {
          this.setState({
            isLoading: false,
            actionType: null,
          });
        });
    });
  };
  handleChange = (event, section) => {
    const { name, value } = event.target;

    if (section === "CPD_Approval") {
      this.setState((prevState) => ({
        cpdClaimApprovalDetail: {
          ...prevState.cpdClaimApprovalDetail,
          [ name ]: value,
        },
      }));
    }
  };

  validateCertificateSelection = () => {
    const selectedMembers = this.state.cpasMembersList.filter(
      (member) => member.isSelected
    );

    if (selectedMembers.length === 0) {
      this.swaServices.Warning("Please select Certificate Number.");
      return false;
    }

    return true;
  };

  setSendRejectionReasonFlag = () => {
    this.setState({ setRejectionReason: true, sendRejectionReason: "" });
  };

  handleChangeSendRejectionReasonDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        sendRejectionReason: data,
      });
    }
  };

  render() {
    const isDisabled = [ 1, 2 ].includes(
      this.state.cpdClaimApprovalDetail?.cpdStatusId
    );
    const isDisabledDet = [ 1, 2, 3 ].includes(
      this.state.cpdClaimApprovalDetail?.cpdStatusId
    );
    return (
      <div>
        <div className="main-body-section">
          <div className="flex">
            <div className="relative flex flex-col flex-1 "></div>
          </div>
          <main className="bg-white px-8 pt-10 pb-12">
            <div className="">
              <div className="col-span-12 mb-4">
                <div className="form-info-title">
                  <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                    CPD Details
                  </h4>
                </div>
              </div>
              <div className="filter-info grid justify-between grid-cols-12 lg:gap-2 md:gap-2">
                <div className="filter-types 2xl:col-span-6 lg:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    Name of ACP
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <TextInput
                    className={`form-input w-full ${isDisabledDet
                        ? "bg-gray-100 cursor-not-allowed opacity-70"
                        : ""
                      }`}
                    name="aCPName"
                    value={this.state.cpdClaimApprovalDetail.aCPName}
                    handleChange={(e) => this.handleChange(e, "CPD_Approval")}
                    disabled={isDisabledDet}
                  />
                </div>

                <div className="lg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12 input-sec-texts">
                  <h2 className="input-title mb-3">
                    Claim Points
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <div className="dropdown">
                    <TextInput
                      className={`form-input w-full ${isDisabledDet
                          ? "bg-gray-100 cursor-not-allowed opacity-70"
                          : ""
                        }`}
                      name="claimPoints"
                      value={this.state.cpdClaimApprovalDetail.claimPoints}
                      handleChange={(e) => this.handleChange(e, "CPD_Approval")}
                      disabled={isDisabledDet}
                    />
                  </div>
                  <span className="text-[#C00000]">
                    {this.state.messageAdd}
                  </span>
                </div>

                <div className="lg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    ACP Registration Number
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <TextInput
                    name="crtificateNumber"
                    className={`form-input w-full ${isDisabledDet
                        ? "bg-gray-100 cursor-not-allowed opacity-70"
                        : ""
                      }`}
                    value={this.state.cpdClaimApprovalDetail.certificateNumber}
                    handleChange={(e) => this.handleChange(e, "CPD_Approval")}
                    disabled={isDisabledDet}
                  />
                </div>

                <div className="flg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12 input-sec-texts">
                  <h2 className="input-title mb-3">
                    Contact Number of ACP
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <NumberInput
                    placeholder=""
                    className={`form-input w-full ${isDisabledDet
                        ? "bg-gray-100 cursor-not-allowed opacity-70"
                        : ""
                      }`}
                    name="acpContactNumber"
                    value={this.state.cpdClaimApprovalDetail.acpContactNumber}
                    handleChange={(e) => this.handleChange(e, "CPD_Approval")}
                    disabled={isDisabledDet}
                  />
                </div>
              </div>
              <div className="col-span-12 mb-4 mt-8">
                <div className="form-info-title">
                  <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                    Activity
                  </h4>
                </div>
              </div>

              <div className="filter-info grid justify-between grid-cols-12 gap-5">
                <div className="lg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    Type of Activity
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <DropdownSelect
                    drpIdentity={"ActivityType"}
                    optionArray={this.state.activityList}
                    setFilterParameters={this.onDropdown.bind(this)}
                    value={this.state.cpdClaimApprovalDetail.activityTypeId}
                    disabled={isDisabledDet}
                  />
                </div>

                <div className="lg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12 input-sec-texts">
                  <h2 className="input-title mb-3">
                    Description
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <textarea
                    name="activityDescription"
                    //  className="w-full"
                    className={`w-full ${isDisabledDet
                        ? "bg-gray-100 cursor-not-allowed opacity-70"
                        : ""
                      }`}
                    value={
                      this.state.cpdClaimApprovalDetail.activityDescription
                    }
                    onChange={(e) => this.handleChange(e, "CPD_Approval")}
                    disabled={isDisabledDet}
                  />
                </div>
                <div className="lg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    Course
                    <span className="text-[#C00000]"> *</span>
                  </h2>
                  <TextInput
                    name="activityName"
                    className={`form-input w-full ${isDisabledDet
                        ? "bg-gray-100 cursor-not-allowed opacity-70"
                        : ""
                      }`}
                    value={this.state.cpdClaimApprovalDetail.activityName}
                    handleChange={(e) => this.handleChange(e, "CPD_Approval")}
                    disabled={isDisabledDet}
                  // onBlur={() => props.validateField("projectTitle", "Project_Cite_Report")}
                  />
                </div>

                <div className="lg:col-span-6 xl:col-span-6 2xl:col-span-6 col-span-12 input-sec-texts">
                  <h2 className="input-title mb-3">
                    Date of Activity
                    <span className="text-[#C00000]"> *</span>
                  </h2>

                  <div className="dropdown">
                    <DateInput
                      name="dateOfIncorporation"
                      value={moment(
                        this.state.cpdClaimApprovalDetail.dateOfIncorporation
                      ).format("YYYY-MM-DD")}
                      handleChange={(e) => this.handleChange(e, "CPD_Approval")}
                      disabled={isDisabledDet}
                    // onBlur={() => props.validateField("projectDateFrom", "Project_Cite_Report")}
                    />
                  </div>
                </div>

                <div className="col-span-12 grid">
                  <h2 className="input-title mb-3">
                    <span
                      className="cursor-pointer text-[#cacaca] ml-1"
                    // onClick={handleFileUploadClick}
                    >
                      <span className="input-title">
                        Certificate for Verification
                      </span>
                      <span className="text-[#C00000]"> *</span>
                      (PDF, DOC, DOCX, XLS, XLSX files only; Max of 5mb)
                    </span>
                    {this.state.cpdClaimApprovalDetail?.documentPath && (
                      <div className="w-auto tm-10">
                        <button
                          type="button"
                          //  className="mt-2 2xl:px-7 lg:px-5 py-2 btn btn-skyblue-border text-xl border text-[#4687C6]"
                          className={`mt-2 2xl:px-7 lg:px-5 py-2 btn btn-skyblue-border text-xl border     ${"text-[#4687C6]"}  `}
                          onClick={() =>
                            this.GetCPASMemberFiles(
                              "Upload_CPD_Submission",
                              this.state.cpdClaimApprovalDetail.documentPath
                            )
                          }
                        >
                          <span className="text-xl text-[#4687C6] font-semibold tracking-normal underline">
                            View Files
                          </span>
                        </button>
                      </div>
                    )}
                    {this.state?.cpdClaimApprovalDetail?.documentPath && (
                      <div className="mt-5 file-uploaded-txt flex items-center">
                        <img
                          src="/check-skyblue.png"
                          className="w-[25px] mr-3"
                          alt=""
                        />

                        <span className="text-[#000]">
                          {this.state.cpdClaimApprovalDetail.documentPath}
                        </span>
                      </div>
                    )}
                  </h2>
                </div>
                <div className="col-span-12 mb-4 mt-8">
                  <div className="form-info-title">
                    <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                      CPD Approval
                    </h4>
                  </div>
                </div>
                <div className="col-span-12 row bg-white w-full rounded-lg shadow p-6">
                  <div className="grid grid-cols-12 gap-4 items-center">
                    <div className="col-span-12 flex items-center">
                      <h2 class="input-title mb-3">
                        ACP Registration Number
                        <span class="text-[#C00000]"> *</span>
                      </h2>
                    </div>
                    <div className="col-span-12 flex items-center">
                      {/* <label className="w-56 font-medium">
                        <span className="input-title">
                          ACP Registration Number{" "}
                        </span>
                        <span className="text-[#C00000]">*</span>
                      </label> */}
                      <input
                        type="text"
                        className="border border-gray-400 px-3 py-2 w-[250px] focus:outline-none"
                        onChange={(e) =>
                          this.setState({ acpSearchText: e.target.value })
                        }
                      />
                      <button
                        className="btn btn-blue text-white  ml-4"
                        onClick={this.handleACPNumberSearch}
                      >
                        Search
                      </button>
                    </div>
                    <div className="col-span-12 mt-1">
                      {this.state.acpValidationMessage && (
                        <span
                          className={
                            this.state.acpValidationType === "success"
                              ? "text-green-600 font-medium"
                              : "text-red-600 font-medium"
                          }
                        >
                          {this.state.acpValidationMessage}
                        </span>
                      )}
                    </div>
                    <div className="col-span-6">
                      {/* <label className="w-56 font-medium">
                        <span className="input-title">Approved Points </span>

                        <span className="text-[#C00000]">*</span>
                      </label> */}
                      <h2 class="input-title mb-3">
                        Approved Points
                      </h2>
                      <input
                        type="number"
                        name="approvedPoints"
                        value={
                          this.state.cpdClaimApprovalDetail.approvedPoints || ""
                        }
                        className="border border-gray-400 px-3 py-2 w-[100%] focus:outline-none"
                        onChange={(e) => this.handleChange(e, "CPD_Approval")}
                      />
                    </div>

                    <div className="col-span-6 pl-45">
                      {/* <label className="w-56 font-medium">
                        <span className="input-title">Registered To</span>
                        <span className="text-[#C00000]">*</span>
                      </label> */}
                      <h2 class="input-title mb-3">
                        Registered To<span class="text-[#C00000]"> *</span>
                      </h2>
                      <input
                        type="text"
                        className="border border-gray-400 px-3 py-2 w-[100%]"
                        value={this.state.registeredTo || ""}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center mt-6">
                    {this.state.isLoading &&
                      this.state.actionType === "reject" ? (
                      <ButtonLoader />
                    ) : (
                      <button
                        className={`btn ${isDisabled
                            ? "bg-gray-100 cursor-not-allowed opacity-70"
                            : "btn-blue text-white"
                          }`}
                        type="button"
                        disabled={this.state.isLoading}
                        onClick={() => {
                          if (isDisabled) return;
                          if (!this.validateBeforeApproveReject("reject")) return;
                          this.setSendRejectionReasonFlag();
                        }}
                      >
                        Reject
                      </button>
                    )}
                    {this.state.isLoading &&
                      this.state.actionType === "approve" ? (
                      <ButtonLoader />
                    ) : (
                      <button
                        disabled={isDisabled || this.state.isLoading}
                        className={`btn ml-auto ${isDisabled
                            ? "bg-gray-100 cursor-not-allowed opacity-70"
                            : "btn-blue text-white"
                          }`}
                        onClick={() => {
                          if (isDisabled) return;
                          if (!this.validateBeforeApproveReject("approve")) return;
                          this.approvedCPD(true);
                        }}
                      >
                        Accept
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
          {this.state.openConfirmModel && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
              <div className="bg-white w-[90%] max-w-4xl rounded-lg shadow-lg p-6 relative">
                <div className="flex justify-between items-center mb-10">
                  <button
                    className="text-xl font-bold ml-auto"
                    onClick={() => {
                      this.setOpenConfirmModel(false);
                      // props.resetProfappModal()
                    }}
                  >
                    X
                  </button>
                </div>
                <div className="grid grid-cols-12 gap-4">
                  <div className="lg:col-span-6 col-span-12 input-sec-texts">
                    <h2 className="input-title mb-3">
                      Search by Certificate Number/Name/Email{" "}
                      <span className="text-[#C00000]">*</span>
                    </h2>

                    <input
                      type="text"
                      name="CertificateNumber"
                      id="CertificateNumber"
                      className="border border-gray-400 px-3 py-2 w-[250px] focus:outline-none"
                      onChange={(e) => this.searchByName(e.target.value)}
                    />
                  </div>
                </div>
                {this.state.cpasMembersList &&
                  this.state.cpasMembersList.length > 0 && (
                    <div className="mt-8">
                      <div className="border rounded-md overflow-hidden">
                        <div className="max-h-60 overflow-y-auto">
                          <table className="min-w-full text-sm">
                            <thead className="bg-gray-100 sticky top-0">
                              <tr>
                                <th className="px-4 py-2 text-center">
                                  <input
                                    type="checkbox"
                                    onChange={this.handleSelectAll}
                                    checked={this.state.selectAll || false}
                                  />
                                </th>
                                <th className="px-4 py-2 text-left">
                                  Certificate Number
                                </th>
                                <th className="px-4 py-2 text-left">
                                  Full Name
                                </th>
                                <th className="px-4 py-2 text-left">Email</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* {JSON.stringify(this.state.cpasMembersList,"this.state.cpasMembersList")} */}
                              {this.state.cpasMembersList.map((item, index) => (
                                <tr key={index} className="border-t">
                                  <td className="px-4 py-2 text-center">
                                    <input
                                      type="checkbox"
                                      checked={item.isSelected || false}
                                      onChange={() =>
                                        this.handleRowSelect(item.cpasMemberId)
                                      }
                                    />
                                  </td>
                                  <td className="px-4 py-2">
                                    {item.certificateNumber}
                                  </td>
                                  <td className="px-4 py-2">{item.fullName}</td>
                                  <td className="px-4 py-2">
                                    {item.emailAddress}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          )}
          {this.state.openAcceptModel && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
              <div className="bg-white w-[90%] max-w-4xl rounded-lg shadow-lg p-6 relative">
                <div className="flex justify-between items-center mb-10">
                  <h3 className="text-lg font-semibold">Please confirm</h3>
                  <button
                    className="text-xl font-bold ml-auto"
                    onClick={() => {
                      this.setOpenAcceptModel(false);
                      // props.resetProfappModal()
                    }}
                  >
                    X
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <SendCpdRejectionReason
          rejectionModal={this.state.setRejectionReason}
          sendRejectionReason={this.state.sendRejectionReason}
          isLoadingRejectAplication={this.state.isLoading}
          setOpenModal={() => this.setState({ setRejectionReason: false })}
          onTinyEceEditorChange={(data) =>
            this.handleChangeSendRejectionReasonDetails(data)
          }
          btn_color={"btn-blue"}
          rejectCpdMemberApplication={() => {
            if (!this.state.sendRejectionReason) {
              this.swaServices.Warning("Please enter rejection reason.");
              return;
            }
            this.approvedCPD(false);
          }}
        />
      </div>
    );
  }
}
